<template>
    <div class="registration-panel-container">
        <div class="inner">
        <!-- Contents -->

        <h1>
            <p class="main">Membership Registration</p>
            <p class="sub">無料会員登録</p>
        </h1>

        <!-- ContentsSwitcher -->
        <div class="contents-switcher">
            <label for="shop" class="item" v-bind:class="{'_on': isShop}"><span>Shop</span></label>
            <label for="brand" class="item" v-bind:class="{'_on': isBrand}"><span>Brand</span></label>
            <label for="showroom" class="item" v-bind:class="{'_on': isShowroom}"><span>Show Room</span></label>
            <div class="active-bg"></div>
        </div>

        <div class="hide-contents-container">

            <!--::::::::::::::::::::::::::::::::::::
                ShopContents
            ::::::::::::::::::::::::::::::::::::-->
            <input name="select-contents" type="radio" id="shop" v-bind:checked="isShop">
            <section class="hide-contents">
                <div class="inner">
                    <p class="main-text">法人・個人でショップをお持ちの方、<br>または、これからショップを始める方は<br>こちらよりお進みください。</p>
                    <h3><span>主な機能</span></h3>
                    <ul class="list_dot">
                        <li class="list_dot-li">
                            <p class="list_dot-p">
                                <span class="list_dot-span">条件検索：ターゲットやプライス等が細かく設定できるこだわり条件検索（検索履歴は保存可能）の利用</span>
                            </p>
                        </li>
                        <li class="list_dot-li">
                            <p class="list_dot-p">
                                <span class="list_dot-span">お気に入り追加：ビジネス対象のリスト確認ができる『My Select Room』の利用</span>
                            </p>
                        </li>
                        <li class="list_dot-li">
                            <p class="list_dot-p">
                                <span class="list_dot-span">チャット：ブランドとのチャットが可能な『AUMAトーク』の利用</span>
                            </p>
                        </li>
                    </ul>
                    <div class="btn_link-wrap _w100">
                        <a href="/registration/shop">
                            <button type="button" class="btn_link"><span>ショップとして登録する</span></button>
                        </a>
                        <div class="bg-element"></div>
                    </div>
                    <div class="text-link-wrap">
                        <p>
                            <a href="/privacy-policy" class="md_text-link _op5"><span>プライバシーポリシー</span></a>
                        </p>
                        <p>
                            <a href="/login" class="md_text-link _op5"><span>すでに会社をご登録済の方はこちら</span></a>
                        </p>
                    </div>
                </div>
            </section>

            <!--::::::::::::::::::::::::::::::::::::
                BrandContents
            ::::::::::::::::::::::::::::::::::::-->
            <input name="select-contents" type="radio" id="brand" v-bind:checked="isBrand">
                <section class="hide-contents">
                    <div class="inner">

                    <p class="main-text">法人・個人でブランドをお持ちの方は<br>こちらよりお進みください。</p>
                    <h3><span>主な機能</span></h3>
                    <ul class="list_dot">
                        <li class="list_dot-li">
                            <p class="list_dot-p">
                                <span class="list_dot-span">アプローチ確認：AUMA内のツールでのショップからのアプローチの確認</span>
                            </p>
                        </li>
                        <li class="list_dot-li">
                            <p class="list_dot-p">
                                <span class="list_dot-span">チャット：ショップとのチャットが可能な『AUMAトーク』の利用</span>
                            </p>
                        </li>
                        <li class="list_dot-li">
                            <p class="list_dot-p">
                                <span class="list_dot-span">情報掲載：ビジネス取引詳細の掲載（展示会・ポップアップ情報等）</span>
                            </p>
                        </li>
                    </ul>
                    <div class="btn_link-wrap _w100">
                        <a href="/registration/brand">
                            <button type="button" class="btn_link"><span>ブランドとして登録する</span></button>
                            <div class="bg-element"></div>
                        </a>
                    </div>
                    <div class="annotation-wrap">
                        <p class="md_annotation">対象 : 製作者様, メーカー様, ショールーム様 </p>
                    </div>
                    <div class="text-link-wrap">
                        <p>
                            <a href="/privacy-policy" class="md_text-link _op5"><span>プライバシーポリシー</span></a>
                        </p>
                        <p>
                            <a href="/login" class="md_text-link _op5"><span>すでに会社をご登録済の方はこちら</span></a>
                        </p>
                    </div>
                </div>
            </section>

            <!--::::::::::::::::::::::::::::::::::::
                ShowRoomContents
            ::::::::::::::::::::::::::::::::::::-->
            <input name="select-contents" type="radio" id="showroom" v-bind:checked="isShowroom">
            <section class="hide-contents">
                <div class="inner">

                    <p class="main-text">AUMAでBASICプランのブランドを<br>2つ以上お持ちの方は<br>こちらよりお進みください。</p>
                    <h3><span>主な機能</span></h3>
                    <ul class="list_dot">
                        <li class="list_dot-li">
                            <p class="list_dot-p">
                                <span class="list_dot-span">情報検索：ブランドとショップ両方のビジネス取引詳細の確認</span>
                            </p>
                        </li>
                        <li class="list_dot-li">
                            <p class="list_dot-p">
                                <span class="list_dot-span">アプローチ確認：AUMA内のツールでのブランド・ショップからのアプローチの確認</span>
                            </p>
                        </li>
                        <li class="list_dot-li">
                            <p class="list_dot-p">
                                <span class="list_dot-span">新規取引先開拓：新たなブランドとの取引で販路を拡大</span>
                            </p>
                        </li>
                    </ul>
                    <div class="btn_link-wrap _w100">
                        <a href="/registration/showroom">
                            <button type="button" class="btn_link"><span>ショールームとして登録する</span></button>
                        </a>
                        <div class="bg-element"></div>
                    </div>
                    <div class="text-link-wrap">
                        <p>
                            <a href="/privacy-policy" class="md_text-link _op5"><span>プライバシーポリシー</span></a>
                        </p>
                        <p>
                            <a href="/login" class="md_text-link _op5"><span>すでに会社をご登録済の方はこちら</span></a>
                        </p>
                    </div>
                </div>
            </section>

        </div><!-- //HideContentsContainer -->

        <!-- //Contents -->
        </div>

        <!-- SwiperBackground -->
        <div class="md_swiper-bg">
            <swiper
                :effect="'fade'"
                :slides-per-view="1"
                :space-between="0"
                :speed="3000"
                :autoplay='{
                    "delay": 5000,
                    "disableOnInteraction": false
                }'
            >
                <swiper-slide>
                    <img src="/img/registration/bg1.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="https://source.unsplash.com/1280x800/?Store" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="https://source.unsplash.com/1280x800/?Store,white" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="https://source.unsplash.com/1280x800/?Store,colorful" alt="">
                </swiper-slide>
            </swiper>
        </div>

    </div>
</template>

<style>
.registration-panel-container .hide-contents .main-text {
    text-align: center;
}
</style>

<script>
    //Swiper.js
    import { Swiper, SwiperSlide } from 'swiper/vue';
    import 'swiper/css';

    //Swiper.js - css
    // import "swiper/css/pagination"
    // import "swiper/css/navigation"
    import 'swiper/css/effect-fade';

    //SwiperModules
    import SwiperCore, {
        Autoplay,
        EffectFade,
        // Pagination,
        // Navigation
    } from 'swiper';
    SwiperCore.use([
        Autoplay,
        EffectFade,
        // Pagination,
        // Navigation
    ]);

    //Common
    import EndUserLayout from '@/Layouts/EndUserLayout'

    export default {
        //Common
        layout: EndUserLayout,
        components: {
            //Swiper.js
            Swiper,
            SwiperSlide,
        },
        data() {
            return {
                isShop: false,
                isBrand: false,
                isShowroom: false,
            }
        },
        created() {
            let params = new URLSearchParams(document.location.search);
            let register = params.get('register');
            if (register) {
                this.isShop = register == 'shop';
                this.isBrand = register == 'brand';
                this.isShowroom = register == 'showroom';
            } else {
                this.isShop = true;
            }
        },
        methods: {
            window: onload = function () {
                //ページが読み込まれたら アニメーションのためのclass付与
                setTimeout(function(){
                    $('.registration-panel-container').addClass('_on');
                }, 1000);
                //選択アクティブ
                $(".contents-switcher .item").click(function () {
                    $(this).siblings().removeClass('_on');
                    $(this).addClass('_on');
                });
            },
        },
    };
</script>
